import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './Main';
import SelectBitget from './SelectBitget';
import SelectBinance from './SelectBinance';
import SetPage from './SetPage';
import SelectPage from './SelectPage';
import SelectPageBinance from './SelectPageBinance';
import SetPageHook from './SetPageHook';
import SetPageLeverage from './SetPageLeverage';
import SetPageRoyal from './SetpageRoyal';
import SetPageKp from './SetpageKp';
import SetPageWz from './SetpageWz';
import SetPageWzBinance from './SetpageWzBinance';
import SetPageRv from './SetpageRv';
import SetPageBurst from './SetPageBurst';
import SetPageUltra from './SetpageUltra';
import SetPageMeme from './SetpageMeme';
import SetPageEscape from './SetpageEscape';
import SetPageHedge from './SetpageHedge';
import SetPageHedgeBinance from './SetpageHedgeBinance';
import SetPageCircle from './SetpageCircle';
import SetPageCirclePro from './SetpageCirclePro';
import SetPageCSupreme from './SetpageCSupreme';
import SetPageCPlus from './SetPageCPlus';
import SetPagePin from './SetpagePin';
import SetPageHold from './SetpageHold';
import SetPageBand from './SetpageBand';
import SamariaSignals from './SamariaSignals';
import UtTurtleSignals from './UtTurtleSignals';
import Signup from './Signup';
import SignupBinance from './SignupBinance';
import Login from './Login';
import LoginBinance from './LoginBinance';
import AdminPage from './adminpage';
import AdminPageBinance from './AdminpageBinance';
import AdminLogin from './AdminLogin';
import AdminCoinsDataBulk from './AdminCoinsDataBulk';
import AdminHoldPage from './AdminHoldPage';
import AdminHoldBulkOps from './AdminHoldBulkOps';
import AdminBandPage from './AdminBandPage';
import AdminBandBulkOps from './AdminBandBulkOps';
import AdminBandCoinsDataBulk from './AdminBandCoinsDataBulk';
import AdminWzPage from './AdminWzPage';
import AdminWzBulkStart from './AdminWzBulkStart';
import AdminWzBulkOps from './AdminWzBulkOps';
import CheckboxPage from './CheckboxPage';
import Withdrawal from './withdrawal';
import HomeTerms from './HomeTerms';
import PrivacyTerms from './PrivacyTerms';
import Explanation from './explanation';
import AnotherAdminPage from './AnotherAdminPage';
import AnotherAdminLogin from './AnontherAdminLogin';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/SelectBitget" element={<SelectBitget />} />
        <Route path="/SelectBinance" element={<SelectBinance />} />
        <Route path="/SignupAts" element={<Signup />} />
        <Route path="/SignupAtsBinance" element={<SignupBinance />} />
        <Route path="/LoginAts" element={<Login />} />
        <Route path="/LoginAtsBinance" element={<LoginBinance />} />
        <Route path="/SetPage" element={<SetPage />} />
        <Route path="/SelectPage" element={<SelectPage />} />
        <Route path="/SelectPageBinance" element={<SelectPageBinance />} />
        <Route path="/SetPageHook" element={<SetPageHook />} />
        <Route path="/SetPageLeverage" element={<SetPageLeverage />} />
        <Route path="/SetPageRoyal" element={<SetPageRoyal />} />
        <Route path="/SetPageKp" element={<SetPageKp />} />
        <Route path="/SetPageWz" element={<SetPageWz />} />
        <Route path="/SetPageWzBinance" element={<SetPageWzBinance />} />
        <Route path="/SetPageRv" element={<SetPageRv />} />
        <Route path="/SetPageBurst" element={<SetPageBurst />} />
        <Route path="/SetPageUltra" element={<SetPageUltra />} />
        <Route path="/SetPageMeme" element={<SetPageMeme />} />
        <Route path="/SetPageEscape" element={<SetPageEscape />} />
        <Route path="/SetPageHedge" element={<SetPageHedge />} />
        <Route path="/SetPageHedgeBinance" element={<SetPageHedgeBinance />} />
        <Route path="/SetPageCircle" element={<SetPageCircle />} />
        <Route path="/SetPageCirclePro" element={<SetPageCirclePro />} />
        <Route path="/SetPageCSupreme" element={<SetPageCSupreme />} />
        <Route path="/SetPageCPlus" element={<SetPageCPlus />} />
        <Route path="/SetPagePin" element={<SetPagePin />} />
        <Route path="/SetPageHold" element={<SetPageHold />} />
        <Route path="/SetPageBand" element={<SetPageBand />} />
        <Route path="/SamariaSignals" element={<SamariaSignals />} />
        <Route path="/UtTurtleSignals" element={<UtTurtleSignals />} />
        <Route path="/Adminpage" element={<AdminPage />} />
        <Route path="/AdminpageBinance" element={<AdminPageBinance />} />
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/AdminCoinsDataBulk" element={<AdminCoinsDataBulk />} />
        <Route path="/AdminHold" element={<AdminHoldPage />} />
        <Route path="/AdminHoldBulkOps" element={<AdminHoldBulkOps />} />
        <Route path="/AdminBand" element={<AdminBandPage />} />
        <Route path="/AdminBandBulkOps" element={<AdminBandBulkOps />} />
        <Route path="/AdminBandCoinsDataBulk" element={<AdminBandCoinsDataBulk />} />
        <Route path="/AdminWz" element={<AdminWzPage />} />
        <Route path="/AdminWzBulkStart" element={<AdminWzBulkStart />} />
        <Route path="/AdminWzBulkOps" element={<AdminWzBulkOps />} />
        <Route path="/CheckboxPage" element={<CheckboxPage />} />
        <Route path="/withdrawal" element={<Withdrawal />} />
        <Route path="/HomeTerms" element={<HomeTerms />} />
        <Route path="/PrivacyTerms" element={<PrivacyTerms />} />
        <Route path="/Explanation" element={<Explanation />} />
        <Route path="/Another_adminpage" element={<AnotherAdminPage />} />
        <Route path="/Another_admin_login" element={<AnotherAdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById('root')); // ReactDOM을 사용하여 App 컴포넌트 렌더링

export default App;
